import { NgModule } from '@angular/core';

import { AdminsSelectDialogFormComponent } from '../components/admins-select-dialog-form/admins-select-dialog-form.component';
import {
  AdminsSelectDialogComponent,
  AdminsSelectDialogData,
} from '../dialogs/admins-select-dialog/admins-select-dialog.component';

@NgModule({
  imports: [AdminsSelectDialogFormComponent, AdminsSelectDialogComponent],
  exports: [AdminsSelectDialogComponent],
})
export class RtAdminSelectSharedModule {}

export { AdminsSelectDialogComponent, AdminsSelectDialogData };
